import { IColuna } from "app/types/IColuna";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";

export function obterColunasEstoquesFiliaisConsultarItens(estoques: RespostaConsultaItensOrcamento["Itens"][0]["ListEstoqueProduto"]["Estoques"], colunas: IColuna[]) : IColuna[] {

    return estoques.map(e => ({
        Codigo: -1, 
        Nome: `F${e.CodigoFilial}`,
        Permitido: colunas.find(c => c.Nome == `F${e.CodigoFilial}`) != null ?  colunas.find(c => c.Nome == `F${e.CodigoFilial}`).Permitido : true,
        Selecionada: colunas.find(c => c.Nome == `F${e.CodigoFilial}`) != null ?  colunas.find(c => c.Nome == `F${e.CodigoFilial}`).Selecionada : true,
        ehEstoqueFilial: true
    }) as IColuna)
}